<template>
        <div class="box commercial-training-course-item">
          <div class="modal-window" :class="{'open': video_box_open}" @click="video_box_open = false" v-if="video_box_open">
            <div class="modal-window-inner" @click.stop>
              <div class="modal-close" @click.stop="video_box_open = false">
                <i class="fal fa-times"></i>
              </div>
              <div class="modal-header">
                <h1 class="modal-title">{{ course.title }}</h1>
              </div>
              <div class="modal-content mb-6">
                  <vue-vimeo-player ref="player" :video-id="course.video_embed_id" :options="{ responsive: true }"/>
              </div>
            </div>
          </div>
          <div class="loading-spinner-outer" v-if="sending">
            <div class="loading-spinner-inner">
              <div class="loading-spinner"></div>
              <div class="loading-spinner-content">
                Saving booking, please wait
              </div>
            </div>
          </div>
            <div class="box-content">
                <h1 class="mt-0 txt-primary">
                    {{ course.title }}
                </h1>
              <div class="flex mb-6">
                <div class="pr-3">
                  <strong>Course Type: </strong> {{ course.commercial_training_course_type.label }}
                </div>
                <div class="flex" v-if="course.commercial_training_course_type_id !== 2"> <!--if not video-->
                  <div class="pr-3">
                    <div>
                      <strong>Start Time:</strong> {{ course.friendly_start_date }}
                    </div>
                  </div>
                  <div>
                    <div>
                      <strong>End Time:</strong> {{ course.friendly_end_date }}
                    </div>
                  </div>
                </div>
              </div>
                <div v-html="course.description"></div>
                <div class="mt-6">
                    <a class="btn-primary" @click="booking_box_open = true" v-if="!logged_in_user.isStaff && !user_booked && course.bookings_open && course.commercial_training_course_type_id !== 2"> <!--if not video & bookings open -->
                        Book a Place
                    </a>
                    <strong v-if="!course.bookings_open && course.commercial_training_course_type_id === 3"> <!--if onsite and bookings not open -->
                      Bookings are no longer being taken for this course.
                    </strong>
                    <strong v-if="!course.bookings_open && course.commercial_training_course_type_id === 1"> <!--if webinar and bookings not open -->
                      Bookings are no longer being taken for this course, a recording will be available to view online shortly.
                    </strong>
                    <a class="btn-primary" @click="video_box_open = true" v-if="course.commercial_training_course_type_id === 2"> <!--if video-->
                      Watch Video
                    </a>
                  <table v-if="user_booked">
                    <tr>
                      <td class="p-3">
                        <strong>You are already booked onto this course</strong>
                      </td>
                      <td>
                        <a class="btn-primary" href="/commercial/training/bookings">View your bookings</a>
                      </td>
                    </tr>
                  </table>
                </div>
            </div>
            <div class="modal-window" :class="{'open': booking_box_open}" @click="booking_box_open = false">
                <div class="modal-window-inner" @click.stop>
                    <div class="modal-close" @click.stop="booking_box_open = false">
                        <i class="fal fa-times"></i>
                    </div>
                    <div class="modal-header">
                        <h1 class="modal-title">Thank you for your interest</h1>
                    </div>
                    <div class="modal-content">
                        <p class="mt-0">
                            <strong>Course: '{{ course.title }}'</strong>
                        </p>
                        <p v-show="course.commercial_training_course_type_id === 1">  <!--webinar-->
                          You will be sent an email confirming your booking, and a further email containing a link to join the webinar on the day of the course.
                          Once the course is completed, a recording will be available to view online.
                        </p>
                        <p v-show="course.commercial_training_course_type_id === 3"> <!--onsite-->
                          You will be sent an email confirming your booking.
                        </p>
                    </div>
                    <div class="modal-footer align-right">
                        <a class="btn-primary" @click="makeBooking()">
                            Book a Place
                        </a>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    props: [
       'logged_in_user',
       'course',
       'user_booked_onto_course',
    ],
    components: {
        vueVimeoPlayer
    },
    data() {
        return {
            loading: true,
            booking_box_open: false,
            video_box_open: false,
            sending: false,
            user_booked: this.user_booked_onto_course,
        };
    },
    methods: {
      makeBooking() {
        this.booking_box_open = false;
        this.sending = true;
        axios.post('/commercial/training/make-booking', {
          'course_id': this.course.id,
        }).then((response) => {
          gtag('event', 'commercial_training_course_booked', {
            'event_category': 'commercial',
            'event_label': 'Commercial training course booked',
            'value': 'Commercial training course booked',
          });

          this.user_booked = true;
          this.sending = false;
          Swal.fire({
            title: 'Course Booked',
            icon: 'success',
            text: 'Your place on this course has been booked, you will be sent an email confirming your booking.',
            confirmButtonText: '<a href="/commercial/training/bookings">View your Bookings</a>',
          });
        });
      },
    },
  watch: {
    video_box_open() {
      if(this.video_box_open) {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 6,
          'description': `Commercial Training Course "${this.course.title}" Video Viewed`,
        });
      }
    },
  },
};
</script>
